import { useState } from "react";
import { Plus, Minus } from "lucide-react";

/**
 * Simple FAQ accordion — also drops a Schema.org FAQPage JSON-LD block
 * directly into the page so Google can rich-render the questions.
 */
export default function FaqAccordion({ items = [] }) {
  const [open, setOpen] = useState(null);
  if (!items || items.length === 0) return null;
  const ld = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": items.map((it) => ({
      "@type": "Question",
      "name": it.q,
      "acceptedAnswer": { "@type": "Answer", "text": it.a },
    })),
  };
  return (
    <section data-testid="shop-faq-accordion">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(ld) }} />
      <ul className="divide-y divide-emerald-100 rounded-2xl border border-emerald-100 bg-white overflow-hidden">
        {items.map((it, idx) => {
          const isOpen = open === idx;
          return (
            <li key={idx}>
              <button
                type="button"
                onClick={() => setOpen(isOpen ? null : idx)}
                className="w-full text-left flex items-start gap-3 px-5 py-4 hover:bg-emerald-50/40 transition"
                aria-expanded={isOpen}
                data-testid={`shop-faq-q-${idx}`}
              >
                <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-emerald-50 text-emerald-700 shrink-0 mt-0.5">
                  {isOpen ? <Minus className="w-3.5 h-3.5" strokeWidth={2} /> : <Plus className="w-3.5 h-3.5" strokeWidth={2} />}
                </span>
                <span className="text-sm font-semibold text-emerald-950 flex-1">{it.q}</span>
              </button>
              {isOpen && (
                <div className="px-5 pb-4 pl-14 text-sm text-emerald-900/80 leading-relaxed" data-testid={`shop-faq-a-${idx}`}>
                  {it.a}
                </div>
              )}
            </li>
          );
        })}
      </ul>
    </section>
  );
}
